import { render, staticRenderFns } from "./ArtistsMenu.vue?vue&type=template&id=1920cc50&"
import script from "./ArtistsMenu.vue?vue&type=script&lang=js&"
export * from "./ArtistsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports